import { findLast, sortBy } from 'lodash';
import { createSelector } from 'reselect';

import selectCustomWebStylesObj from './selectCustomWebStylesObj';

export enum ECustomWebStylesScope {
  PatientApp = 'patientApp',
  PatientAppV2 = 'patientAppV2',
  PatientFormsV3 = 'patientFormsV3',
}

export type TMakeSelectCustomWebStyleArgs = {
  id?: string;
  scope?: ECustomWebStylesScope;
  onlyPublished?: boolean;
};

const makeSelectCustomWebStyle = ({ id, scope, onlyPublished }: TMakeSelectCustomWebStyleArgs = {}) =>
  createSelector(selectCustomWebStylesObj, (customWebStylesObj) => {
    if (id) return customWebStylesObj[id];

    return findLast(sortBy(customWebStylesObj, 'createdAt'), (obj) => {
      if (onlyPublished && !obj.published) return false;
      if (scope === ECustomWebStylesScope.PatientFormsV3) return obj?.scope === scope;
      // Styles < v3 don't necessary have the scope defined
      return !obj?.scope || obj?.scope === scope || obj?.scope === 'patientForm';
    });
  });

export default makeSelectCustomWebStyle;
